import { useEffect, useRef, useState } from 'react';

const products = [
  {
    id: 'entry',
    tag: '初學階段',
    tagColor: '#4a6741',
    tagBg: '#eaede5',
    subtitle: '入門最合理的投資範圍',
    name: '入門練習箏',
    price: 'NT$ 12,000 – 20,000',
    priceNote: '初學入門最友善的價格帶',
    image: 'https://storage.helloreaddy.io/project_files/79c1f631-1cb7-456b-a6cf-fdd8ff21e9a0/88a8c5e1-3d7f-400f-9e79-8fcb9262f5a6_compressed_C--Image-202695-11_26_36.webp',
    desc: '對初學者而言，最重要的不是買到「好」的琴，而是買到「對的」琴。入門練習箏的設計以穩定性為主，讓你的耳朵在正確的環境下養成，而不是被不穩定的音色干擾學習。',
    suitableFor: [
      '完全初學者，尚未接觸過古箏',
      '還在探索是否要長期學習的人',
      '預算有限，但想認真體驗者',
    ],
    useContext: [
      '初次接觸古箏、感受樂器基本手感',
      '在家中穩定練習基本功與指法',
      '建立音感，養成正確的耳朵判斷力',
    ],
    features: [
      { label: '音準穩定', detail: '基礎音準表現穩定，適合耳力養成階段' },
      { label: '弦距舒適', detail: '琴弦張力較輕，初學者手指友善不疼痛' },
      { label: '維護簡單', detail: '不易因環境變化與彈奏習慣改變音色' },
      { label: '決策輕鬆', detail: '價格親民、選項明確，減少選擇壓力' },
    ],
    advice: [
      '建議先諮詢後再購買，入門琴個體音色差異仍需專業協助判斷。',
      '不急著買，可以先上幾堂課感受後再決定。',
    ],
  },
  {
    id: 'mid',
    tag: '穩定學習',
    tagColor: '#7a6248',
    tagBg: '#f5f0e8',
    subtitle: '學了一段時間、想升級的選擇',
    name: '中階演奏箏',
    price: 'NT$ 20,000 – 45,000',
    priceNote: '穩定學習階段的升級投資',
    image: 'https://readdy.ai/api/search-image?query=high%20quality%20guzheng%20zither%20with%20lacquered%20body%20and%20fine%20silk%20strings%20displayed%20elegantly%20on%20wooden%20stage%2C%20warm%20amber%20light%2C%20artistic%20product%20photography%2C%20clean%20minimal%20background%2C%20rich%20wood%20grain%20visible&width=1200&height=500&seq=guzheng_mid&orientation=landscape',
    desc: '當你開始對聲音的細節有更多感受，想要更豐富的音色回饋時，中階演奏箏會讓你的演奏體驗有明顯的提升。這個階段的升級是值得的投資——你能聽出差異，也能感受更好的回饋。',
    suitableFor: [
      '已穩定練習 6 個月以上的學員',
      '對入門琴音色感到不夠滿足的人',
      '確定要長期投入古箏學習者',
    ],
    useContext: [
      '課堂演奏與日常練習的主力琴',
      '開始追求音色層次與細節表現',
      '想讓技法更完整展現的進階階段',
    ],
    features: [
      { label: '音色層次', detail: '音色更豐富細緻，表現力明顯提升' },
      { label: '演奏回饋', detail: '觸弦回饋感更好，技法表達更完整' },
      { label: '共鳴品質', detail: '共鳴板材質提升，聲音有深度與延展性' },
      { label: '長期價值', detail: '值得長期使用的投資，陪伴你度過學習主階段' },
    ],
    advice: [
      '建議先使用入門琴一段時間，對音色有明確偏好後再升級，這樣才能選到最適合自己的琴。',
    ],
  },
  {
    id: 'advanced',
    tag: '深度演奏',
    tagColor: '#9a6a40',
    tagBg: '#f8f0e6',
    subtitle: '追求極致音色的演奏者',
    name: '高階演奏箏',
    price: 'NT$ 50,000 以上',
    priceNote: '為深度演奏者打造的工藝級樂器',
    image: 'https://readdy.ai/api/search-image?query=premium%20professional%20guzheng%20instrument%20with%20exquisite%20carved%20details%20and%20premium%20lacquer%20finish%2C%20dramatic%20warm%20studio%20lighting%2C%20luxury%20artisan%20craftsmanship%2C%20rich%20deep%20warm%20wood%20tones%2C%20fine%20art%20product%20photography&width=1200&height=500&seq=guzheng_advanced&orientation=landscape',
    desc: '高階演奏箏是一種很個人的選擇——每把琴都有自己的聲音個性，選擇的過程本身就是一種深度的體驗。如果你走到了這個階段，表示你對古箏的聲音已經有了自己的理解。',
    suitableFor: [
      '有明確演奏需求的進階學員',
      '希望擁有一把有個性的琴的人',
      '預算充足且長期深度投入古箏者',
    ],
    useContext: [
      '個人演奏、錄音、公開演出場合',
      '追求獨特音色風格與聲音個性',
      '將古箏視為長期收藏與演奏雙重資產',
    ],
    features: [
      { label: '頂級工藝', detail: '頂級木料與手工製作，每把琴都有唯一性格' },
      { label: '極致音色', detail: '音色極為細緻豐富，能呈現演奏者個人風格' },
      { label: '獨特個性', detail: '高階琴個體差異大，每把都值得親自感受' },
      { label: '雙重價值', detail: '兼具演奏表現力與收藏傳承價值' },
    ],
    advice: [
      '務必親自試彈，高價琴的音色偏好非常主觀。',
      '不急著決定，多聽、多感受再選擇，這把琴值得你慢慢挑。',
    ],
  },
];

function useVisible(threshold = 0.1) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return { ref, visible };
}

export default function InstrumentCatalog() {
  const { ref, visible } = useVisible();
  const [activeId, setActiveId] = useState('entry');
  const active = products.find((p) => p.id === activeId) ?? products[0];

  return (
    <section id="catalog" className="py-24 md:py-32 bg-[#f2ede5]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div
          ref={ref}
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* ==================== Section Header ==================== */}
          <div className="text-center mb-14">
            <div className="flex items-center justify-center gap-3 mb-5">
              <div className="divider-gold"></div>
              <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">Products &amp; Pricing</span>
              <div className="divider-gold"></div>
            </div>
            <h2 className="font-serif-tc text-[#2c2420] leading-[1.35] mb-4" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}>
              古箏產品介紹與費用範圍
            </h2>
            <p className="text-[1.1875rem] leading-[1.75] text-[#7a6e62] max-w-xl mx-auto">
              依學習階段分為三個等級，幫你快速找到現在最適合的選擇。
            </p>
          </div>

          {/* ==================== Stage Selector ==================== */}
          <div className="flex justify-center mb-16">
            <div className="inline-flex bg-white rounded-full p-1.5 border border-[#e8ddd0] shadow-sm">
              {products.map((p) => (
                <button
                  key={p.id}
                  onClick={() => setActiveId(p.id)}
                  className={`flex items-center gap-2.5 px-6 py-3 rounded-full text-[0.9375rem] font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    activeId === p.id
                      ? 'bg-[#5a3e22] text-white shadow-md'
                      : 'text-[#7a6e62] hover:text-[#3a2e22] hover:bg-[#f5f0e8]'
                  }`}
                >
                  <span
                    className="w-2 h-2 rounded-full shrink-0 transition-colors duration-300"
                    style={{ background: activeId === p.id ? '#fff' : p.tagColor }}
                  ></span>
                  {p.name}
                </button>
              ))}
            </div>
          </div>

          {/* ==================== Active Product ==================== */}
          <div className="max-w-4xl mx-auto">

            {/* ===== 第一層：產品標頭區 ===== */}
            <div className="text-center mb-10">
              {/* 小標 */}
              <span
                className="inline-block px-3.5 py-1.5 rounded-full text-[0.8125rem] font-semibold tracking-[0.05em] mb-5"
                style={{ background: active.tagBg, color: active.tagColor }}
              >
                {active.tag}
              </span>

              {/* 副標 */}
              <p className="text-[1.0625rem] leading-relaxed text-[#9a8470] font-medium mb-1">
                {active.subtitle}
              </p>

              {/* 主標 */}
              <h3
                className="font-serif-tc text-[#2c2420] leading-[1.2] mb-6"
                style={{ fontSize: 'clamp(1.75rem, 3vw, 2.25rem)', letterSpacing: '0.02em' }}
              >
                {active.name}
              </h3>

              {/* 價格 */}
              <div className="inline-block bg-white rounded-xl border border-[#e8ddd0] px-6 py-4">
                <p className="text-[0.6875rem] uppercase tracking-[0.2em] text-[#b0a090] font-semibold mb-2">
                  {active.priceNote}
                </p>
                <p className="text-[2rem] font-extrabold text-[#5a3e22] tracking-tight leading-none">
                  {active.price}
                </p>
              </div>
            </div>

            {/* ===== 第二層：導言區 ===== */}
            <div className="max-w-2xl mx-auto mb-12">
              <div className="flex items-center justify-center gap-3 mb-7">
                <div className="w-12 h-[2px] bg-[#c8b89a]"></div>
                <span className="text-[0.75rem] tracking-[0.15em] text-[#b0a090] font-medium uppercase">Overview</span>
                <div className="w-12 h-[2px] bg-[#c8b89a]"></div>
              </div>
              <p className="text-center text-[0.9375rem] leading-[1.9] text-[#5a4e42]">
                {active.desc}
              </p>
            </div>

            {/* ===== 第三層：產品主視覺圖片 ===== */}
            <div className="mb-14">
              <div className="relative rounded-2xl overflow-hidden border border-[#e8ddd0] bg-[#f5f0e8]" style={{ aspectRatio: '12/5' }}>
                <img
                  src={active.image}
                  alt={active.name}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c2420]/10 via-transparent to-transparent pointer-events-none"></div>
                <div className="absolute bottom-5 left-5">
                  <span
                    className="inline-block px-3.5 py-1.5 rounded-full text-[0.8125rem] font-semibold backdrop-blur-sm shadow-sm"
                    style={{ background: `${active.tagColor}15`, color: active.tagColor, border: `1px solid ${active.tagColor}30` }}
                  >
                    {active.tag}
                  </span>
                </div>
              </div>
            </div>

            {/* ===== 第四層：2x2 四宮格資訊模組 ===== */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">

              {/* Module 1: 適合對象 */}
              <div className="bg-white rounded-xl border border-[#ede5d8] overflow-hidden transition-shadow duration-300 hover:shadow-sm">
                <div className="flex items-center gap-3 px-5 py-4 border-b border-[#f0ebe0] bg-[#faf8f5]">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#7a6248]/10 flex-shrink-0">
                    <i className="ri-user-heart-line text-[#7a6248] text-base"></i>
                  </div>
                  <span className="text-[0.8125rem] font-bold text-[#7a6248] uppercase tracking-[0.12em]">適合對象</span>
                </div>
                <ul className="px-5 py-4 space-y-3">
                  {active.suitableFor.map((s, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#7a6248] shrink-0 mt-2.5"></span>
                      <span className="text-[0.9375rem] leading-[1.7] text-[#4a3e32]">{s}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Module 2: 適用情境 */}
              <div className="bg-white rounded-xl border border-[#ede5d8] overflow-hidden transition-shadow duration-300 hover:shadow-sm">
                <div className="flex items-center gap-3 px-5 py-4 border-b border-[#f0ebe0] bg-[#faf8f5]">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#9a8470]/10 flex-shrink-0">
                    <i className="ri-lightbulb-line text-[#9a8470] text-base"></i>
                  </div>
                  <span className="text-[0.8125rem] font-bold text-[#9a8470] uppercase tracking-[0.12em]">適用情境</span>
                </div>
                <ul className="px-5 py-4 space-y-3">
                  {active.useContext.map((u, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#9a8470] shrink-0 mt-2.5"></span>
                      <span className="text-[0.9375rem] leading-[1.7] text-[#4a3e32]">{u}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Module 3: 產品特色 */}
              <div className="bg-white rounded-xl border border-[#ede5d8] overflow-hidden transition-shadow duration-300 hover:shadow-sm">
                <div className="flex items-center gap-3 px-5 py-4 border-b border-[#f0ebe0] bg-[#faf8f5]">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#4a6741]/10 flex-shrink-0">
                    <i className="ri-star-line text-[#4a6741] text-base"></i>
                  </div>
                  <span className="text-[0.8125rem] font-bold text-[#4a6741] uppercase tracking-[0.12em]">產品特色</span>
                </div>
                <div className="px-5 py-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {active.features.map((f, i) => (
                    <div
                      key={i}
                      className="bg-[#faf8f5] rounded-lg p-3.5 border border-[#ede5d8]/60"
                    >
                      <p className="text-[0.875rem] font-bold text-[#3a2e22] mb-1">{f.label}</p>
                      <p className="text-[0.8125rem] leading-[1.6] text-[#7a6e62]">{f.detail}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Module 4: 建議 / 提醒 */}
              <div className="bg-[#fdfaf5] rounded-xl border border-[#ede5d8] overflow-hidden transition-shadow duration-300 hover:shadow-sm">
                <div className="flex items-center gap-3 px-5 py-4 border-b border-[#ede5d8] bg-[#faf5ec]">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#b08060]/15 flex-shrink-0">
                    <i className="ri-information-line text-[#b08060] text-base"></i>
                  </div>
                  <span className="text-[0.8125rem] font-bold text-[#b08060] uppercase tracking-[0.12em]">建議 / 提醒</span>
                </div>
                <ul className="px-5 py-4 space-y-3">
                  {active.advice.map((a, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#b08060] shrink-0 mt-2.5"></span>
                      <span className="text-[0.9375rem] leading-[1.7] text-[#5a4e62]">{a}</span>
                    </li>
                  ))}
                </ul>
              </div>

            </div>

            {/* ===== 第五層：CTA ===== */}
            <div className="text-center">
              <a
                href="https://line.me"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-[#5a3e22] hover:bg-[#3a2e22] text-white text-[0.9375rem] font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md"
              >
                <i className="ri-line-fill text-[#06C755] text-lg"></i>
                詢問{active.name}選購建議
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}